import memoize from 'lru-memoize';
import {linuxUserRules, createValidator, required, maxLength, email, noSpecialChars, noSpaces, minLength} from 'utils/validation';

const createClientValidation = createValidator({
  login: [required, linuxUserRules, minLength(3), maxLength(8)],
  email: [required, email],
});
export default memoize(10)(createClientValidation);
